import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { formatCurrency } from "../../../Utils/helpers";

export default function AcceptPayoutRequestModal({
  show,
  onHide,
  request,
  isProcessing,
  onConfirm,
}) {
  if (!request) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop={isProcessing ? "static" : true}
      keyboard={!isProcessing}
      className="premium-cms-modal dp-payout-modal"
    >
      <Modal.Header className="cms-modal__header">
        <div className="cms-modal__header-main">
          <div className="cms-modal__header-icon">
            <i className="fas fa-hand-holding-usd" />
          </div>
          <div>
            <Modal.Title>Accept Payout Request</Modal.Title>
            <p className="cms-modal__subtitle">
              Driver requested a withdrawal from their wallet balance.
            </p>
          </div>
        </div>
        {!isProcessing && (
          <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
        )}
      </Modal.Header>

      <Modal.Body className="cms-modal__body">
        <div className="dp-request-driver-card">
          <div className="dp-driver-cell__avatar">{request.name.charAt(0)}</div>
          <div>
            <span className="dp-driver-cell__name">{request.name}</span>
            <span className="dp-request-driver-card__meta">{request.email}</span>
          </div>
        </div>

        <div className="dp-confirm-summary dp-confirm-summary--2col">
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Requested Amount</span>
            <strong>{formatCurrency(request.requestedAmount)}</strong>
          </div>
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Requested On</span>
            <strong>{moment(request.requestedAt).format("MMM D, YYYY • h:mm A")}</strong>
          </div>
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Remaining Wallet</span>
            <strong>{formatCurrency(request.walletBalance)}</strong>
          </div>
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Bank Account</span>
            <strong>
              {request.bankLast4
                ? `${request.bankName} •••• ${request.bankLast4}`
                : "Not linked"}
            </strong>
          </div>
        </div>

        {request.note && (
          <div className="dp-request-note">
            <span className="dp-request-note__label">Driver Note</span>
            <p>{request.note}</p>
          </div>
        )}

        {request.payoutBlocked && (
          <div className="dp-confirm-warning">
            <i className="fas fa-exclamation-triangle" />
            <div>
              <strong>Payout blocked</strong>
              <p>{request.blockReason || "Bank account must be linked and verified before payout."}</p>
            </div>
          </div>
        )}

        {!request.payoutBlocked && request.failureReason && (
          <div className="dp-confirm-warning">
            <i className="fas fa-exclamation-triangle" />
            <div>
              <strong>Last attempt failed</strong>
              <p>{request.failureReason}</p>
            </div>
          </div>
        )}

        {!request.payoutBlocked && (
          <p className="dp-confirm-note">
            <i className="fas fa-info-circle" />
            On accept, {formatCurrency(request.requestedAmount)} is transferred instantly to the
            driver's Stripe account. Stripe then pays it out to their bank (usually 2–5 business days).
          </p>
        )}
      </Modal.Body>

      <Modal.Footer className="cms-modal-footer">
        <button
          type="button"
          className="cms-btn-cancel"
          onClick={onHide}
          disabled={isProcessing}
        >
          Cancel
        </button>
        <button
          type="button"
          className="cms-btn-save"
          onClick={onConfirm}
          disabled={isProcessing || request.payoutBlocked}
        >
          {isProcessing ? (
            <>
              <span className="dp-spinner" />
              Processing…
            </>
          ) : (
            <>
              <i className="fas fa-check me-2" />
              Accept & Pay
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
